



import Pagination from '@mui/material/Pagination';
import axios from "axios";
import { useEffect, useRef, useState } from "react";
import { FaUserAlt } from "react-icons/fa";
import { MdEdit } from "react-icons/md";
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import { useNavigate } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Swal from "sweetalert2";
import BrandHeader from "./BrandHeader";
import Navbar from "./Navbar";
import '../../App.css';
const MyCampaigns = () => {
  const [myCampaigns, setMyCampaigns] = useState([]);
  const [loading, setLoading] = useState(false);
  const [loadingProfileImage, setLoadingProfileImage] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(6);
  const [selectedCampaign, setSelectedCampaign] = useState(null);
  const [modalOpen, setModalOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const [isSmallScreen, setIsSmallScreen] = useState(false);
  const navigate = useNavigate();
  const fileInputRef = useRef({});
  const logoInputRef = useRef({});
  const brandId = localStorage.getItem("brandID");

  useEffect(() => {
    if (brandId) {
      fetchCampaigns(brandId);
    } else {
      toast.error("No brand ID found in localStorage!");
    }
  }, []);

  const fetchCampaigns = async (brandId) => {
    try {
      setLoading(true);
      const response = await fetch(`https://server-side-influencer.onrender.com/brand/getMyCampaigns/${brandId}`);
      const data = await response.json();
      if (data.success) {
        setMyCampaigns(data.data);
      } else {
        toast.error(data.message || "Failed to fetch campaigns");
      }
    } catch (error) {
      toast.error("Error fetching campaigns");
    } finally {
      setLoading(false);
    }
  };

  const handleDeleteCampaign = async (id) => {
    const result = await Swal.fire({
      title: "Are you sure?",
      text: "Do you want to delete this campaign?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "Cancel",
    });

    if (result.isConfirmed) {
      try {
        const response = await fetch(`https://server-side-influencer.onrender.com/brand/deleteCampaign/${brandId}/${id}`, {
          method: "DELETE",
          headers: { "Content-Type": "application/json" },
        });
        const data = await response.json();
        if (data.success) {
          setMyCampaigns((prev) => prev.filter((c) => c._id !== id));
          toast.success("Campaign deleted successfully!");
        } else {
          toast.error(data.message || "Failed to delete campaign");
        }
      } catch (error) {
        toast.error("Error deleting campaign");
      }
    }
  };

  const handleViewApplicants = (campaignId) => {
    navigate(`/applicant/${campaignId}`);
  };

  const handleCampaignClick = (campaign) => {
    setSelectedCampaign(campaign);
    setModalOpen(true);
  };

  const handleImageEditClick = (e, campaignId) => {
    e.stopPropagation();
    if (fileInputRef.current[campaignId]) {
      fileInputRef.current[campaignId].click();
    }
  };

  const handleLogoEditClick = (e, campaignId) => {
    e.stopPropagation();
    if (logoInputRef.current[campaignId]) {
      logoInputRef.current[campaignId].click();
    }
  };

  const handleImageUpload = async (event, campaignId) => {
    const file = event.target.files[0];
    if (!file) return;

    const formData = new FormData();
    formData.append("image", file);

    try {
      const res = await fetch(`https://server-side-influencer.onrender.com/brand/campaignimage/${campaignId}`, {
        method: "POST",
        body: formData,
      });
      const data = await res.json();

      if (data.success) {
        toast.success("Campaign image uploaded successfully!");
        setMyCampaigns((prev) =>
          prev.map((c) => (c._id === campaignId ? { ...c, campaignImages: data.data.campaignImages } : c))
        );
      } else {
        toast.error(data.error || "Failed to upload campaign image.");
      }
    } catch (err) {
      toast.error("Error uploading campaign image.");
    }
  };

  const uploadProfileImage = async (imageFile, campaignId) => {
    setLoadingProfileImage(true);
    const formData = new FormData();
    formData.append("image", imageFile);

    try {
      const res = await axios.post(
        `https://server-side-influencer.onrender.com/brand/uploadbrandimage/${brandId}`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      if (res.data.success) {
        toast.success("Profile image uploaded successfully!");
        fetchCampaigns(brandId);
      } else {
        toast.error("Failed to upload profile image.");
      }
    } catch (error) {
      toast.error("Error uploading profile image.");
    } finally {
      setLoadingProfileImage(false);
    }
  };

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 780);
      setIsSmallScreen(window.innerWidth <= 780);
    };
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const closeModal = () => {
    setModalOpen(false);
    setSelectedCampaign(null);
  };

  const indexOfLastCampaign = currentPage * itemsPerPage;
  const indexOfFirstCampaign = indexOfLastCampaign - itemsPerPage;
  const currentCampaigns = myCampaigns.slice(indexOfFirstCampaign, indexOfLastCampaign);
  const totalPages = Math.ceil(myCampaigns.length / itemsPerPage);

  return (
    <div className="flex h-screen bg-white  hide-scrollbar">
<div className="text-white fixed top-0 left-0 bottom-0 z-50"><Navbar /></div>

      <div className="absolute top-0 left-0 w-full z-40 ml-0">
        <BrandHeader page="My Campaign" />
      </div>

      <div className="ml-10 w-full min-h-screen bg-white flex flex-col mt-16">
        <div className="p-4">
          <h2 className="text-2xl font-bold mb-8 text-center text-black-700 mt-4">My Campaigns</h2>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-3 gap-6">
            {loading ? (
              Array.from({ length: 6 }).map((_, index) => (
                <div key={index} className="rounded-3xl shadow-md p-4">
                  <Skeleton height={180} />
                  <div className="flex items-center mt-3">
                    <Skeleton circle width={48} height={48} />
                    <Skeleton width={120} height={20} className="ml-2" />
                  </div>
                  <Skeleton count={2} className="mt-2" />
                </div>
              ))
            ) : currentCampaigns.length === 0 ? (
              <p className="text-center text-gray-500">No campaigns found!</p>
            ) : (
              currentCampaigns.map((campaign) => (
                <div
                  key={campaign._id}
                  style={{ marginLeft: isSmallScreen ? '0px' : '40px' }}
                  className="relative max-w-[600px] h-[380px] bg-white rounded-3xl shadow-lg overflow-hidden hover:shadow-2xl transition duration-300 cursor-pointer ml-0 mt-10"
                  onClick={() => handleCampaignClick(campaign)}
                >
                  {/* Imagessss */}
                  <div className="h-1/2 bg-gray-200 relative">
                    {/* <div className="h-full w-full bg-cover bg-center" style={{ backgroundImage: `url(${campaign.campaignImages?.[0] || "https://via.placeholder.com/300x200?text=No+Image"})` }}> */}
                     <div
  className="h-full w-full"
  style={{
    height: isSmallScreen ? '190px' : '190px', // taller on larger devices
    backgroundImage: `url(${campaign.campaignImages[0] || "https://via.placeholder.com/300x200?text=No+Image"})`,
    backgroundSize: '100% 100%', // behaves like object-fillsss
    backgroundRepeat: 'no-repeat'
  }}
>
                      <div className="absolute inset-0 bg-black/30" />
                    </div>
                    <div className="absolute top-2 right-2 bg-white p-1 rounded-full shadow cursor-pointer z-20" onClick={(e) => handleImageEditClick(e, campaign._id)}>
                      <MdEdit size={20} className="text-gray-700" />
                      <input
                        type="file"
                        accept="image/*"
                        className="hidden"
                        ref={(el) => (fileInputRef.current[campaign._id] = el)}
                        onChange={(e) => handleImageUpload(e, campaign._id)}
                      />
                    </div>
                  </div>

                  {/* Logo + Edit */}
                  <div className="absolute left-1 top-[47%] z-10 transform translate-y-1/2 flex justify-between w-[calc(100%-2rem)] items-center px-4">
                    <div className="flex items-center relative">
                      <img src={campaign.logo || "https://i.postimg.cc/brqZVdrP/dummypic.jpg"} alt="Brand Logo" className="w-14 h-14 rounded-full border-2 border-white shadow-md bg-white object-cover" />
                      <div className="absolute top-[-6px] left-[48px] bg-white p-1 rounded-full shadow cursor-pointer" onClick={(e) => handleLogoEditClick(e, campaign._id)}>
                        <MdEdit size={18} className="text-gray-700" />
                        <input
                          type="file"
                          accept="image/*"
                          className="hidden"
                          ref={(el) => (logoInputRef.current[campaign._id] = el)}
                          onChange={(e) => uploadProfileImage(e.target.files[0], campaign._id)}
                        />
                      </div>
                      <h3 className="ml-2 text-xs font-bold text-gray-800">{campaign.brandName}</h3>
                    </div>
                    <div className="flex gap-2 ml-7">
                      <button onClick={(e) => { e.stopPropagation(); handleDeleteCampaign(campaign._id); }} className="bg-red-600 hover:bg-red-700 text-white text-xs py-1 px-3 rounded-md shadow-md">
                        Delete
                      </button>
                      <button onClick={(e) => { e.stopPropagation(); handleViewApplicants(campaign._id); }} className="bg-blue-600 hover:bg-blue-700 text-white text-xs py-1 px-3 rounded-md shadow-md flex items-center">
                        <FaUserAlt size={12} className="mr-1" />
                        View
                      </button>
                    </div>
                  </div>

                  {/* Name */}
                  <div className="p-4 pt-6 flex flex-col gap-2 relative h-1/2 mt-4">
                    <h3 className="text-lg font-bold text-gray-800 mt-8 text-center">{campaign.campaignName}</h3>
                  </div>
                </div>
              ))
            )}
          </div>

          {myCampaigns.length > itemsPerPage && (
            <div className="flex justify-center mt-6">
              <Pagination
                count={totalPages}
                page={currentPage}
                onChange={(e, value) => setCurrentPage(value)}
                color="primary"
                shape="rounded"
                size="large"
              />
            </div>
          )}
        </div>
      </div>

      {modalOpen && selectedCampaign && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
          <div className="bg-white p-6 rounded-lg w-3/4 md:w-1/2 xl:w-1/3 relative">
            <button onClick={closeModal} className="absolute top-2 right-2 text-2xl font-bold text-gray-500">X</button>
            <h2 className="text-2xl font-bold mb-4 text-center">{selectedCampaign.campaignName}</h2>
            <p className="mb-2"><strong>Campaign Type:</strong> {selectedCampaign.campaignType}</p>
            <p className="mb-2"><strong>Description:</strong> {selectedCampaign.description}</p>
            <p className="mb-2"><strong>Start Date:</strong> {selectedCampaign.startDate?.slice(0, 10)}</p>
            <p className="mb-2"><strong>End Date:</strong> {selectedCampaign.endDate?.slice(0, 10)}</p>
            <p className="mb-2"><strong>Budget:</strong> {selectedCampaign.budget}</p>
            <p className="mb-2"><strong>Task:</strong> {selectedCampaign.task}</p>
          </div>
        </div>
      )}

      <ToastContainer />
    </div>
  );
};

export default MyCampaigns;
